import { useParams } from 'react-router-dom';
import AdminLayout from '@/components/Layout/AdminLayout';
import Alert from '@/components/UI/Alert';
import { DataLoadingSpinner } from '@/components/UI/DataLoadingSpinner';
import { trpc } from '@/api/trpc';
import { useAppQuery } from '@/hooks/useAppQuery';
import { OperatorAlertDetails } from './OperatorAlertDetails';

const OperatorAlertContent = () => {
    const { id = '' } = useParams();
    const query = useAppQuery(
        { ...trpc.admin.getOperatorAlert.queryOptions({ id }), retry: false, gcTime: 0 },
        {
            fallbackErrorMessage: 'Could not load these diagnostics',
            showErrorToast: false
        }
    );
    const snapshot = query.data;

    if (query.isPending) return <DataLoadingSpinner />;
    if (query.error || !snapshot)
        return (
            <Alert variant="warning">
                {query.error?.message ?? 'These diagnostics are unavailable.'} The email attachment remains available.
            </Alert>
        );

    return <OperatorAlertDetails key={snapshot.id} snapshot={snapshot} />;
};

const OperatorAlert = () => (
    <AdminLayout title="Operator diagnostics">
        <OperatorAlertContent />
    </AdminLayout>
);

export default OperatorAlert;
